import { http } from '..';
import type { CreateInternalRequestDto } from './types';

export const createInternalRequest = async (data: CreateInternalRequestDto) => {
  return http.url('/admin/internal-requests').post(data).res();
};
